import React from 'react';
import Section from './Section';

const Contact = () => {
  return (
    <Section id="contact" title="Contact Us">
      <p>For any inquiries, please get in touch with the organizing team through the contact form or email address provided here.</p>
    </Section>
  );
};

export default Contact;
